import { useMemo } from "react";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import OptionGroup from "../types/OptionGroup";

const useOptionGroups = (field: IField, funnels: Funnel[]): OptionGroup[] | undefined =>
  useMemo(() => {
    if (field.hasFeature(FieldFeature.STAGE_FIELD)) {
      return funnels.map(({ id, name }) => ({ id, name }));
    }
    return undefined;
  }, [field, funnels]);
export default useOptionGroups;
